import TrustMarkers from 'src/components/shared/TrustMarkers'
import Section from 'src/components/shared/Section'
import Typography from 'src/components/shared/Typography'

const RatingSection = ({ trustMarkersCombination }) => (
  <Section className="bg-[#f5f9ff]">
    <Typography
      className="mb-4"
      component="h2"
      variant="labelOverline"
      color="information"
      align="center"
    >
      FREEDOM DEBT RELIEF IS TRUSTED BY 1 MILLION CLIENTS AND COUNTING
    </Typography>
    <div
      className="mx-auto w-66 lg:w-full"
      data-testid="facts-rating-trust-markers"
    >
      <TrustMarkers
        trustMarkersCombination={trustMarkersCombination}
        isDynamic
      />
    </div>
  </Section>
)

export default RatingSection
